import React, { Component } from "react";
import PostTable from "./PostTable";
import MinNav from "../component/MinNav";

class AllPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      interests: [],
      storeState: true
    };

    this.postDelete = this.postDelete.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({ storeState: false });
    let searchValues = e.target.value;
    fetch(`${this.props.apiROOT}post/search/${searchValues}`)
      .then(res => res.json())
      .then(data => {
        if (data.posts.length > 0) {
          this.setState({ posts: data.posts });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  postDelete(e) {
    let postID = e.target.getAttribute("data-id");
    let isDeleted = e.target.getAttribute("data-isdeleted");
    let action = parseInt(isDeleted) === 0 ? "delete" : "retreive";
    fetch(`${this.props.apiROOT}post/${action}/${postID}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          //eslint-disable-next-line
          this.state.posts.map((p, i) => {
            if (p.post_id === postID) {
              let isDeleted = parseInt(this.state.posts[i].isDeleted);
              if (isDeleted === 0) {
                //eslint-disable-next-line
                this.state.posts[i].isDeleted = 1;
              } else {
                //eslint-disable-next-line
                this.state.posts[i].isDeleted = 0;
              }
            }
          });
          this.setState({ posts: this.state.posts });
        }
      });
  }

  componentDidMount() {
    fetch(`${this.props.apiROOT}post/adminPost`)
      .then(res => res.json())
      .then(data => {
        this.setState({ 
          posts: data.posts
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    return (
      <div className="a-container">
        <MinNav />
        <div style={{ padding: 5 + "px " + 1 + "%" }}>
          <input
            placeholder="Search post title, post ID..."
            onChange={this.onChange}
            style={{ background: "#f9f9f9", width: 99 + "%" }}
          />
        </div>

        <PostTable
          posts={this.state.posts}
          apiROOT={this.props.apiROOT}
          postDelete={this.postDelete}
        />
      </div>
    );
  }
}

export default AllPost;
